import { render, staticRenderFns } from "./PrintTagSubheader.vue?vue&type=template&id=4cf604ec"
import script from "./PrintTagSubheader.vue?vue&type=script&lang=js"
export * from "./PrintTagSubheader.vue?vue&type=script&lang=js"
import style0 from "./PrintTagSubheader.vue?vue&type=style&index=0&id=4cf604ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports